import defaultChallengeImage from 'img/default-challenge-image.jpg';

/** Matches AppServices teamName: `S{seasonId}: {displayName}` → displayName. */
function stripCoordinatorTeamName(name) {
    if (typeof name !== 'string')
        return name || '';
    const match = name.match(/^S(\d+):\s*(.*)$/);
    return match ? match[2] : name;
}

const ChallengeUtils = {
    stripCoordinatorTeamName,
    Types : {
        1:  "Read & Confirm",
        2:  "Timed Challenge",
        5:  "Camera Challenge",
        6:  "Count Up Challenge",
        7:  "Timed Log Challenge",
        8:  "Camera Log Challenge",
        9:  "All Day Log Challenge",
        11: "Survey Challenge",
        12: "Double Log Challenge",
        13: "Timed Double Log Challenge",
        14: "All Day Log Challenge",
        15: "Photo Challenge",
        16: "Camera And Choice Challenge",
        17: "Photo Log Challenge",
        18: "Photo And Choice Challenge",
        19: "Log Challenge",
    },
    formatDuration(t, duration) {
        if(duration > 0) {
            return t('challenges:::format_duration', {count:duration});
        }
        return '';
    },
    getChallengeImageUrl(challenge) {
        if(challenge.image && (challenge.image.url||'').length>0) {
            return challenge.image.url;
        } else {
            return defaultChallengeImage;
        }
    }
};

export default ChallengeUtils;
